import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { restorePortalSession } from '../utils/api';
import { dashboardReturnUrl, portalLoginUrl } from '../utils/portalLogin';

const HomeV5: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let disposed = false;
    // Вход на портале (start.3a-fb.info) приходит cookie: без локального токена восстанавливаем сессию.
    restorePortalSession().then((loggedIn) => {
      if (loggedIn && !disposed) navigate('/dashboard', { replace: true });
    });
    return () => { disposed = true; };
  }, [navigate]);

  return (
    <section className="u2-card is-gradient">
      <div className="u2-cardInner">
        <div className="u2-cardHeader">
          <div>
            <h1 className="u2-title" style={{ fontSize: 22 }}>Whitepage Generator</h1>
            <p className="u2-subtitle">Войдите в систему, чтобы перейти в дашборд и генератор.</p>
          </div>
          <span className="u2-badge is-soon">beta</span>
        </div>

        <div className="u2-divider" />

        <div className="u2-grid cols-2" style={{ alignItems: 'start' }}>
          <div className="u2-card" style={{ boxShadow: 'none', background: 'var(--u2-surface-3)' }}>
            <div className="u2-cardInner">
              <div className="u2-strong">Доступ</div>
              <div className="u2-muted" style={{ fontSize: 12, marginTop: 6 }}>
                Внутри доступны: генератор V2, история генераций, профиль, админ‑инструменты (для admin).
              </div>
              <div className="u2-divider" />
              <div className="u2-grid cols-2">
                <a className="u2-btn is-primary" href={portalLoginUrl({ returnUrl: dashboardReturnUrl() })}>
                  Войти
                </a>
                <a className="u2-btn is-secondary" href={portalLoginUrl({ register: true, returnUrl: dashboardReturnUrl() })}>
                  Регистрация
                </a>
              </div>
            </div>
          </div>

          <div className="u2-card" style={{ boxShadow: 'none', background: 'var(--u2-surface-3)' }}>
            <div className="u2-cardInner">
              <div className="u2-strong">Генератор V2</div>
              <div className="u2-muted" style={{ fontSize: 12, marginTop: 6 }}>
                Мастер настройки: шаблон → тема → компоненты → локализация → фон → генерация.
              </div>
              <div className="u2-divider" />
              <Link className="u2-btn is-secondary" to="/generator-v2">
                Открыть генератор
              </Link>
              <div className="u2-muted" style={{ fontSize: 12, marginTop: 10 }}>
                Если вы не авторизованы, система попросит войти.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeV5;




